import React, { Component } from "react";
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBIcon } from "mdbreact";
import axios from "axios";
import ConfigData from "../Components/config";
import RatingModal from "../Components/RatingModal";
import Swal from "sweetalert2";
import "./datarubrong.css";

const STATUS_FILTERS = [
  { key: "all", label: "ทั้งหมด" },
  { key: "waiting", label: "รอดำเนินการ" },
  { key: "payable", label: "รอชำระเงิน" },
  { key: "ready", label: "พร้อมรับ/ดาวน์โหลด" },
  { key: "done", label: "เสร็จสมบูรณ์" },
  { key: "rejected", label: "ไม่อนุมัติ" },
];

export default class Datarubrong extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalpay: false,
      TYPEPITITION_NAME: null,
      ID_NO: null,
      stopdate: null,
      TERM: null,
      name: null,
      lname: null,
      amount: null,
      idcertificate: null,
      array_ShowReportPetition: [],
      tableFilter: "",
      tablePage: 1,
      statusFilter: "all",
      feedback: 0,
      feedback1: 0,
      feedback2: 0,
      openratting: false,
    };
    this.rateTimer = null;
    this.modalpay_close = this.modalpay_close.bind(this);
    this.payment = this.payment.bind(this);
    this.Alert = this.Alert.bind(this);
    this.CheckRate = this.CheckRate.bind(this);
    this.SendRate = this.SendRate.bind(this);
  }

  componentDidMount() {
    if (!localStorage.getItem("token")) {
      window.location.href = "/rubrongkpru";
    }
    axios
      .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/ShowReportPetition/" + localStorage.getItem("id"))
      .then((ShowReportPetition) => {
        if (ShowReportPetition.data.length !== 0) {
          this.setState({
            array_ShowReportPetition: ShowReportPetition.data,
          });
        } else {
          this.setState({ array_ShowReportPetition: [] });
        }
      });
    let num = 0;
    this.rateTimer = setInterval(() => {
      num = num + 1;
      if (num === 15) {
        this.CheckRate();
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.rateTimer) {
      clearInterval(this.rateTimer);
    }
  }

  SendRate() {
    axios
      .post("https://mua.kpru.ac.th/FrontEnd_Rating/rating/check", {
        feedback: this.state.feedback,
        feedback1: this.state.feedback1,
        feedback2: this.state.feedback2,
        system_kpru: "10",
        id_no: localStorage.getItem("id"),
      })
      .then(() => {
        this.Alert();
      });
  }

  CheckRate() {
    axios
      .get("https://mua.kpru.ac.th/FrontEnd_Rating/rating/check/" + localStorage.getItem("id") + "/10")
      .then((res) => {
        const data = res.data;
        if (data.success === 0) {
          this.setState({ openratting: true });
        }
      });
  }

  Alert() {
    Swal.fire({
      icon: "success",
      title: "ขอบคุณสำหรับการประเมิน",
      timer: 1200,
      timerProgressBar: true,
      showConfirmButton: false,
    }).then(() => {
      this.setState({ openratting: false });
    });
  }

  formatPayDate() {
    const day = new Date().getDate();
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear() + 543;
    const dayText = day < 10 ? "0" + day : String(day);
    const monthText = month < 10 ? "0" + month : String(month);
    return dayText + "/" + monthText + "/" + year;
  }

  splitLocalName() {
    const raw = localStorage.getItem("name") || "";
    const separators = ["   ", "  ", " ", "    "];
    for (let i = 0; i < separators.length; i++) {
      const parts = raw.split(separators[i]);
      if (parts.length === 2) {
        return { name: parts[0], lname: parts[1] };
      }
    }
    return { name: raw, lname: "" };
  }

  openPayModal(index) {
    const item = this.state.array_ShowReportPetition[index];
    if (!item) {
      return;
    }
    const amount =
      (parseInt(item.NUM_RUBRONGTH) + parseInt(item.NUM_RUBRONGEN)) * item.TYPEPITITION_MONEY;
    const names = this.splitLocalName();
    this.setState({
      modalpay: true,
      TYPEPITITION_NAME: item.TYPEPITITION_NAME,
      ID_NO: item.ID_NO,
      stopdate: this.formatPayDate(),
      TERM: item.TERM,
      name: names.name,
      lname: names.lname,
      amount: amount,
      idcertificate: item.ID_NUMBER,
    });
  }

  modalpay_close(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.setState({
      modalpay: false,
      ID_NO: null,
      stopdate: null,
      TERM: null,
      name: null,
      lname: null,
      amount: null,
      idcertificate: null,
    });
  }

  payment(event) {
    event.preventDefault();
    window.open(
      "https://e-payment.kpru.ac.th/pay/typepayment?comp=80899&orderRef1=0" +
        this.state.ID_NO +
        "&amount=" +
        this.state.amount +
        "&endDate=" +
        this.state.stopdate +
        "&urlredirect=https://e-student.kpru.ac.th/rubrongkpru/Datarubrong&term=" +
        this.state.TERM +
        "&name=" +
        this.state.name +
        "&lname=" +
        this.state.lname +
        "&orderRef5=" +
        this.state.idcertificate,
      "_blank"
    );
  }

  OpenRpt(idNumber, lang) {
    axios.get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/PrintPetition/" + idNumber).then(() => {
      if (String(lang) === "1") {
        window.open("https://e-certificate.kpru.ac.th/downloads_file/" + idNumber + "-thai.pdf", "_blank");
      } else {
        window.open("https://e-certificate.kpru.ac.th/downloads_file/" + idNumber + "-en.pdf", "_blank");
      }
      axios
        .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/ShowReportPetition/" + localStorage.getItem("id"))
        .then((ShowReportPetition) => {
          if (ShowReportPetition.data.length !== 0) {
            this.setState({
              array_ShowReportPetition: ShowReportPetition.data,
            });
          } else {
            this.setState({ array_ShowReportPetition: [] });
          }
        });
    });
  }

  getStatusMeta(data) {
    const status = String(data.STATUS);
    const type = String(data.RUBRONG_TYPE || "");
    const downloadGroup = type === "1 " || type === "2 " || type === "3 " || type === "4 " || type === "31";
    const pickupPhoto = type === "26" || type === "27" || type === "28" || type === "29" || type === "37";
    const pickupOther = type === "30" || type === "32" || type === "33";

    if (status === "0") {
      return {
        group: "rejected",
        label: data.REASON_HEADTABIAN ? "ไม่อนุมัติ" : "ไม่อนุญาตให้ชำระเงิน",
        tone: "reject",
        reason: data.REASON_HEADTABIAN || data.REASON_TABIAN || "",
        action: null,
      };
    }
    if (status === "1") {
      return { group: "waiting", label: "รองานทะเบียนอนุมัติชำระเงิน", tone: "wait", action: null };
    }
    if (status === "2") {
      return { group: "payable", label: "พร้อมชำระเงิน", tone: "pay", action: "pay" };
    }
    if (status === "3") {
      return { group: "waiting", label: "รอการอนุมัติ", tone: "wait", action: null };
    }
    if (status === "5") {
      return { group: "waiting", label: "รอการอนุมัติจากอาจารย์ที่ปรึกษา", tone: "wait", action: null };
    }
    if (status === "4") {
      if (downloadGroup) {
        if (data.DATECOUNT > 0) {
          if (type === "4 ") {
            return { group: "ready", label: "ติดต่อขอรับได้ที่งานทะเบียน", tone: "info", action: null };
          }
          return { group: "ready", label: "พร้อมดาวน์โหลด", tone: "info", action: "download" };
        }
        return { group: "done", label: "เสร็จสมบูรณ์", tone: "done", action: null };
      }
      if (pickupPhoto) {
        return { group: "ready", label: "ติดต่อขอรับได้ที่งานทะเบียน", tone: "info", action: null };
      }
      if (data.PRINT_STATUS === "1" || data.PRINT_STATUS === 1) {
        return { group: "done", label: "เสร็จสมบูรณ์", tone: "done", action: null };
      }
      if (pickupOther) {
        return { group: "ready", label: "ติดต่อขอรับได้ที่งานทะเบียน", tone: "info", action: null };
      }
      return { group: "ready", label: "พร้อมดาวน์โหลด", tone: "info", action: "download" };
    }
    return { group: "waiting", label: "รอดำเนินการ", tone: "wait", action: null };
  }

  getStatusCounts(list) {
    const counts = { all: list.length, waiting: 0, payable: 0, ready: 0, done: 0, rejected: 0 };
    list.forEach((data) => {
      const group = this.getStatusMeta(data).group;
      if (counts[group] !== undefined) {
        counts[group] += 1;
      }
    });
    return counts;
  }

  handleTableFilter = (event) => {
    this.setState({ tableFilter: event.target.value, tablePage: 1 });
  };

  setStatusFilter(key) {
    this.setState({ statusFilter: key, tablePage: 1 });
  }

  getVisibleRows(list) {
    const q = (this.state.tableFilter || "").trim().toLowerCase();
    const filter = this.state.statusFilter || "all";
    let rows = (list || []).map((data, index) => ({ data, index }));
    if (filter !== "all") {
      rows = rows.filter(({ data }) => this.getStatusMeta(data).group === filter);
    }
    if (q) {
      rows = rows.filter(({ data }) => {
        const meta = this.getStatusMeta(data);
        const haystack = [
          data.DATE_INSERT,
          data.TYPEPITITION_NAME,
          data.DETAIL,
          data.NUM_RUBRONGTH,
          data.NUM_RUBRONGEN,
          meta.label,
          meta.reason,
        ]
          .filter((value) => value !== null && value !== undefined)
          .join(" ")
          .toLowerCase();
        return haystack.includes(q);
      });
    }
    const pageSize = 30;
    const pages = Math.max(1, Math.ceil(rows.length / pageSize));
    const page = Math.min(this.state.tablePage || 1, pages);
    return {
      rows: rows.slice((page - 1) * pageSize, page * pageSize),
      total: rows.length,
      page,
      pages,
    };
  }

  renderDownloadButtons(data) {
    return (
      <div className="status-actions">
        {data.NUM_RUBRONGTH > "0" ? (
          <button type="button" className="status-btn primary" onClick={() => this.OpenRpt(data.ID_NUMBER, "1")}>
            ดาวน์โหลดไทย
          </button>
        ) : null}
        {data.NUM_RUBRONGEN > "0" ? (
          <button type="button" className="status-btn secondary" onClick={() => this.OpenRpt(data.ID_NUMBER, "2")}>
            ดาวน์โหลดอังกฤษ
          </button>
        ) : null}
      </div>
    );
  }

  renderStatus(data, index) {
    const meta = this.getStatusMeta(data);
    return (
      <div className="status-cell">
        <span className={"status-badge " + meta.tone}>{meta.label}</span>
        {meta.reason ? <div className="status-reason">{meta.reason}</div> : null}
        {meta.action === "pay" ? (
          <div className="status-actions">
            <button type="button" className="status-btn primary" onClick={() => this.openPayModal(index)}>
              ชำระเงินค่าเอกสาร
            </button>
          </div>
        ) : null}
        {meta.action === "download" ? this.renderDownloadButtons(data) : null}
      </div>
    );
  }

  renderQty(data) {
    return (
      <div className="status-qty">
        <span className={"status-qty-chip" + (data.NUM_RUBRONGTH > "0" ? " is-on" : "")}>
          ไทย {data.NUM_RUBRONGTH || 0}
        </span>
        <span className={"status-qty-chip" + (data.NUM_RUBRONGEN > "0" ? " is-on" : "")}>
          อังกฤษ {data.NUM_RUBRONGEN || 0}
        </span>
      </div>
    );
  }

  renderPager(visible) {
    if (visible.pages <= 1) {
      return null;
    }
    return (
      <div className="status-pager">
        <button
          type="button"
          className="btn btn-sm btn-light"
          disabled={visible.page <= 1}
          onClick={() => this.setState({ tablePage: visible.page - 1 })}
        >
          ก่อนหน้า
        </button>
        <span>
          หน้า {visible.page} / {visible.pages} ({visible.total} รายการ)
        </span>
        <button
          type="button"
          className="btn btn-sm btn-light"
          disabled={visible.page >= visible.pages}
          onClick={() => this.setState({ tablePage: visible.page + 1 })}
        >
          ถัดไป
        </button>
      </div>
    );
  }

  render() {
    const list = this.state.array_ShowReportPetition || [];
    const counts = this.getStatusCounts(list);
    const visible = this.getVisibleRows(list);
    const hasData = list.length > 0;

    return (
      <>
        <div className="status-page">
          <div className="status-hero">
            <div>
              <h1>สถานะการขอเอกสารทางการศึกษา</h1>
              <p>ติดตามคำร้อง ชำระเงิน และดาวน์โหลดเอกสารได้จากหน้านี้</p>
            </div>
            <a className="status-add" href="/rubrongkpru/Addpetition">
              <MDBIcon icon="plus" /> เพิ่มคำร้อง
            </a>
          </div>

          {hasData ? (
            <div className="status-stats">
              {STATUS_FILTERS.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={"status-stat" + (this.state.statusFilter === item.key ? " is-active" : "")}
                  onClick={() => this.setStatusFilter(item.key)}
                >
                  <b>{counts[item.key] || 0}</b>
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          ) : null}

          <section className="status-card">
            {hasData ? (
              <>
                <div className="status-card-head">
                  <strong>รายการคำร้องของฉัน</strong>
                  <input
                    type="search"
                    className="form-control status-search"
                    placeholder="ค้นหาวันที่ ประเภทเอกสาร หรือสถานะ..."
                    value={this.state.tableFilter}
                    onChange={this.handleTableFilter}
                  />
                </div>

                {visible.total === 0 ? (
                  <div className="status-empty">
                    <h2>ไม่พบรายการที่ตรงกับเงื่อนไข</h2>
                    <p>ลองเปลี่ยนคำค้นหา หรือเลือกสถานะอื่นด้านบน</p>
                  </div>
                ) : (
                  <>
                    <div className="status-table-wrap">
                      <table className="status-table">
                        <thead>
                          <tr>
                            <th>ลำดับ</th>
                            <th>วันที่ร้องขอ</th>
                            <th>เอกสาร</th>
                            <th>จำนวน</th>
                            <th>สถานะ / การดำเนินการ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {visible.rows.map(({ data, index }) => (
                            <tr key={data.ID_NUMBER || index}>
                              <td>{index + 1}</td>
                              <td>{data.DATE_INSERT}</td>
                              <td>
                                <div className="status-doc">
                                  <strong>{data.TYPEPITITION_NAME}</strong>
                                  {data.DETAIL ? <span>{data.DETAIL}</span> : null}
                                </div>
                              </td>
                              <td>{this.renderQty(data)}</td>
                              <td>{this.renderStatus(data, index)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="status-cards">
                      {visible.rows.map(({ data, index }) => (
                        <div className="status-mobile-card" key={(data.ID_NUMBER || index) + "-card"}>
                          <div className="status-mobile-top">
                            <div className="status-doc">
                              <strong>{data.TYPEPITITION_NAME}</strong>
                              <span className="status-mobile-date">
                                ลำดับ {index + 1} · {data.DATE_INSERT}
                              </span>
                            </div>
                          </div>
                          {data.DETAIL ? <div className="status-doc"><span>{data.DETAIL}</span></div> : null}
                          <div className="status-mobile-qty">{this.renderQty(data)}</div>
                          {this.renderStatus(data, index)}
                        </div>
                      ))}
                    </div>
                    {this.renderPager(visible)}
                  </>
                )}
              </>
            ) : (
              <div className="status-empty">
                <h2>ยังไม่มีคำร้องขอเอกสาร</h2>
                <p>เริ่มยื่นคำร้องใหม่ได้จากปุ่มด้านล่าง</p>
                <a className="status-add" href="/rubrongkpru/Addpetition">
                  <MDBIcon icon="plus" /> เพิ่มคำร้อง
                </a>
              </div>
            )}
          </section>
        </div>

        <RatingModal
          isOpen={this.state.openratting}
          values={{
            feedback: this.state.feedback,
            feedback1: this.state.feedback1,
            feedback2: this.state.feedback2,
          }}
          onChange={(field, score) => this.setState({ [field]: score })}
          onSubmit={() => this.SendRate()}
        />

        <MDBModal className="pay-modal" size="md" isOpen={this.state.modalpay} toggle={this.modalpay_close} centered>
          <MDBModalHeader toggle={this.modalpay_close}>ชำระค่าเอกสารทางการศึกษา</MDBModalHeader>
          <MDBModalBody>
            <p className="pay-lead">ตรวจสอบรายละเอียดก่อนไปหน้าชำระเงินออนไลน์</p>
            <div className="pay-summary">
              <div className="pay-row">
                <span>ประเภทเอกสาร</span>
                <strong>{this.state.TYPEPITITION_NAME || "-"}</strong>
              </div>
              <div className="pay-row">
                <span>วันที่</span>
                <strong>{this.state.stopdate || "-"}</strong>
              </div>
              <div className="pay-row total">
                <span>ยอดชำระ</span>
                <strong>{this.state.amount != null ? this.state.amount + " บาท" : "-"}</strong>
              </div>
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <button type="button" className="pay-go" onClick={this.payment}>
              ชำระเงินออนไลน์
              <span className="pay-logos">
                <img src="https://e-payment.kpru.ac.th/pay/public/images/Visa_Mastercard_jcb.jpg" alt="Visa Mastercard JCB" />
                <img src="https://e-payment.kpru.ac.th/pay/public/images/logo_ktb_next.png" alt="Krungthai Next" />
                <img src="https://e-payment.kpru.ac.th/pay/public/images/promtpay1.png" alt="PromptPay" />
              </span>
            </button>
            <button type="button" className="pay-close" onClick={this.modalpay_close}>
              ปิด
            </button>
          </MDBModalFooter>
        </MDBModal>
      </>
    );
  }
}
